export const translation = {
  title: "SDA Hymnal",
  title_store: "SDA Hymnal Ultimate",
  path_hymn: "hymn",
  path_present: "present",
  path_sheet_music: "sheet-music",
  path_chords: "chords",
  share_app: "Share SDA Hymnal",
  fullscreen_exit: "Exit Fullscreen",
  fullscreen: "Fullscreen",
  settings: "Settings",
  search_hymns: "Search Hymns",
  no_favorites: "No favorites.",
  no_hymns_to_learn: "No hymns to learn.",
  no_history: "No history.",
  hymn_count: 695,
  website_base_url: "https://sdahymnal.co.za",
  url_play_store: "https://play.google.com/store/apps/details?id=za.co.sdahymnal",
  url_app_store: "https://apps.apple.com/us/app/sda-hymnal-offline-music/id6744000691",
  correction_message: "Thanks for helping out with SDA Hymnal." +
    "\n\nPlease describe your suggestion in this email and/or make any edits to the hymn below" +
    " and highlight the changes. " +
    "Once the edits are done, please send this email to the pre-filled address. " +
    "We will review your suggestion and update it in a future version if necessary.",
  correction_subject: "Suggestion for Correction - Hymn",
  correction_email: "kaalvoetjaco@gmail.com",
  share_message: '🎵🎹 SDA Hymnal with offline music, themes, instruments and autoplay! 🎻🎶' +
    '\n' +
    '\nDownload for free: ' +
    '\n' +
    '\nPlay Store: https://play.google.com/store/apps/details?id=za.co.sdahymnal' +
    '\n' +
    '\nApp Store: https://apps.apple.com/us/app/sda-hymnal-offline-music/id6744000691' +
    '\n' +
    '\nOr use it online: https://sdahymnal.co.za',
  hymn: "Hymn",
  verse: "Verse",
  refrain: "Refrain",
  hymn_number_too_large: "`Hymn number cannot be more than 695`",
  text_size: 'Text Size',
  instruments: "Instruments",
  time_between_repeats: "Pause Between Repeats",
  time_between_repeats_description: "Delay between repeats when a hymn loops",
  timeBetweenRepeatsDefaultMs: 0,
  useSeparateIntroMidi: true,
  instrument: {
    piano: "Piano",
    organ: "Organ",
    violin: "Violin",
    harp: "Harp",
    flute: "Flute",
    guitar: "Guitar",
    ensemble: "Ensemble",
    random: "Random",
    none: "None",
    synth: "Synth",
    electric_piano: "Electric Piano",
    voice: "Choir",
    music_box: "Music Box",
    lead: "Lead",
    accompaniment: "Accompaniment",
  },
  autoscroll_disabled: 'Hymn Autoscroll Disabled',
  autoscroll_enabled: 'Hymn Autoscroll Enabled',
  karaoke_enabled: 'Karaoke Mode Enabled',
  autoscroll_enabled_disable_verse_buttons: 'Autoscroll is enabled. Disable autoscroll to manually select verses.',
  scroll_mode: 'Scroll Mode',
  scroll_mode_off: 'Off',
  scroll_mode_off_description: 'Manual scrolling',
  scroll_mode_autoscroll: 'Autoscroll',
  scroll_mode_autoscroll_description: 'Automatic scrolling based on progress',
  scroll_mode_karaoke: 'Karaoke',
  scroll_mode_karaoke_description: 'Highlights lyrics and follows along',
  presentation_scroll_mode: 'Slide Mode',
  presentation_manual_mode: 'Manual Mode',
  presentation_manual_description: 'Manual slide transitions',
  presentation_autoscroll: 'Autoscroll',
  presentation_autoscroll_enabled: 'Presentation Autoscroll Enabled',
  presentation_autoscroll_description: 'Auto-advance after last visible lyric',
  presentation_karaoke: 'Karaoke',
  presentation_karaoke_enabled: 'Presentation Karaoke Mode Enabled',
  presentation_karaoke_description: 'Highlights and auto-advances',
  play_all_favorites: 'Play All Favorites',
  play_all_favorites_description: "Random order with lyrics automatically scrolling",
  random_favorite: "Random Favorite",
  random_favorite_description: "Open any favorite hymn",
  random_hymn_description: "Open any hymn",
  continued: "continued",
  add_to_favorites: "Add to Favorites",
  add_to_hymns_to_learn: "Add to Want to Learn",
  random_hymn: "Random Hymn",
  listen: "Listen",
  stop: "Stop",
  remove_from_favourites: "Remove from Favorites",
  remove_from_hymns_to_learn: "Remove from Want to Learn",
  go_to_hymn_number: "Go to Hymn Number",
  change_font_size: "Font Controls",
  label_font_size: "Font Size",
  label_lines_per_verse: "Lines per Verse",
  label_font_weight: "Font Weight",
  label_alignment: "Alignment",
  label_text_outline: "Text Outline",
  share_hymn: "Share Hymn",
  shortcuts: "Keyboard Shortcuts",
  suggest_correction: "Suggest Correction",
  lines_per_verse: 'Lines per Verse',
  stop_automatic_playback: "Stop Automatic Playback",
  title_full: "SDA Hymnal",
  presentation_mode: "Presentation Mode",
  sheet_music_mode: "Sheet Music",
  chord_mode: "Chords",
  read_mode: "Read Mode",
  shortcut: {
    display_shortcuts: "Show Keyboard Shortcuts",
    hymn_list: "Show Hymn List",
    keypad: "Show Keypad",
    random_hymn: "Random Hymn",
    random_favorite: "Random Favorite",
    play_pause: "Play / Stop Music",
    autoscroll: "Enable Hymn Autoscroll",
    change_mode: "Presentation Mode / Read Mode",
    next_verse: "Next Verse",
    next_hymn: "Next Hymn",
    previous_verse: "Previous Verse",
    previous_hymn: "Previous Hymn",
    go_to_refrain: "Go to Refrain",
    go_to_number: "Go to Verse Number",
    increase_fontsize: "Increase Text Size",
    decrease_fontsize: "Decrease Text Size",
    increase_playback_speed: "Faster Tempo",
    decrease_playback_speed: "Slower Tempo",
    reset_playback_speed: "Reset Tempo",
  },
  what_is_new_title: "What's New in SDA Hymnal",
  press_back_to_exit: "Press 'back' button again to exit",
  info_messages: null,
  app_base_key: "za.co.sdahymnal",
  app_settings_key: "za.co.sdahymnal.settings",
  themes: "Themes",
  theme: {
    light: "Light",
    bird: "Glide",
    blossoms: "Blossoms",
    clouds: "Yellow Rose",
    desert: "Desert",
    field: "Flower Field",
    geese: "Geese",
    hills: "Hills",
    lake: "Twilight",
    ocean: "Beach",
    path: "Path",
    seascape: "Dusk Coast",
    stars: "Stars",
    thunderstorm: "Thunderstorm",
    wheat: "Wheat",
    dark: "Dark",
    black: "Black",
  },
  enable_background: "Show Background",
  blur_background: "Blur Background",
  music: "Music",
  play_intro: "Play Introduction",
  text: "Text",
  text_outline: "Outline",
  screen_timeout: "Keep Screen On",
  screen_timeout_description: "The screen will be kept on, even if the app is not being interacted with",
  screen_allowsleep_description: "The screen turns off after a certain period of inactivity",
  saved_hymns: "Saved Hymns",
  clear_favorites: "Clear Favorites",
  clear_favorites_confirm: "Are you sure you want to remove all your favorite hymns?",
  clear_hymns_to_learn: "Clear Want to Learn",
  clear_history: "Clear History",
  clear_hymns_to_learn_confirm: "Are you sure you want to remove all your 'Want to Learn' hymns?",
  clear_history_confirm: "Are you sure you want to clear your history?",
  play_all_hymns: 'Play all Hymns',
  play_all_hymns_description: 'Random order with words that automatically move across the screen',
  extra: 'Extra',
  all_hymns: 'All Hymns',
  favorites: 'Favorites',
  hymns_to_learn: 'Want to Learn',
  history: 'History',
  faster_tempo: "Faster Tempo",
  slower_tempo: "Slower Tempo",
  reset_tempo: "Reset Tempo",
  transpose: "Transpose Key",
  increase_key_one: "Raise key",
  decrease_key_one: "Lower key",
  reset_transpose: "Reset Key",

  path_guess_the_hymn: "guess-the-hymn",
  card_title_guess_the_hymn: "Guess the Hymn",
  card_description_guess_the_hymn: "Can you guess which hymn matches the tune?",
  url: "https://www.sdahymnal.co.za",

  use_online: "Online Hymnal",
  use_online_description: "Visit sdahymnal.co.za on your computer, projector, or smart TV",
  guess_the_hymn: {
    title: "Guess the Hymn",
    scoreboard_title: "🏆 Scoreboard",
    add_more_favorites: "Add {x} more hymns to Favorites or \"Want to learn\" to choose this option",
    single_player: "Single Player",
    two_player: "Two Players",
    two_player_instruction: "Choose the correct option before the other player. The first player with {x} points is the winner!",
    which_hymn: "Which hymn is playing now?",
    you_win: "You win! 🥇",
    you_lose: "Second place! 🥈",
    draw: "Draw! 🤝",
    correct: "Correct! ⭐",
    too_slow: "Too Slow! 🐢",
    incorrect: "Incorrect! ❌",
    single_player_instruction: "Choose as many correct hymns as possible before you run out of hearts!",
    well_done: "Well done!",
    game_over: "Game Over 💔",
    new_high_score: "New high score! 🎉",
    fast: `That was fast! 🔥`,
    correct_single: `Correct! ✓️`,
    incorrect_single: `Incorrect! 💔`,
    volume_up: "Make sure your sound is on",
    exit: "Exit",
    wait_for_player: "Wait for player",
    begin: "Start",
    score: "Score",
  },
  new: "NEW",
  debug: false,
  enableDisableInstruments: "Enable or disable instruments. Disabled instruments will not appear in the music menu and will not be used when a random instrument is selected.",
  chords_not_available: "Chords Not Available"
};
